import { app }                        from '../app';
import { ISessionService }            from '../services/SessionService';
import { IBrowserControlService }     from '../services/BrowserControlService';
import { IQuestionnaireLogicService } from '../services/LogicService';
import { SharedQuestionService }      from '../services/SharedQuestionService';
import { ITranslationService }        from '../services/TranslationService';
import { IThemerService }             from '../services/ThemerService';
import { LoggerKey }                  from '../services/LoggerService';
import { LoggerService }              from '../services/LoggerService';
import { SharedQuestion }             from '../sharedQuestions/SharedQuestion';
import { SpinnerService }             from '../services/SpinnerService';
import { ErrorService }               from '../services/ErrorService';
import moment = require('moment/moment');
import IScope = angular.IScope;

export class SessionController {

    private rootScope:IRootScope;
    private scope:ng.IScope;
    private location:ng.ILocationService;
    private q:ng.IQService;
    private window:ng.IWindowService;
    private timeout:ng.ITimeoutService;
    private interval:ng.IIntervalService;
    private route:ng.route.IRouteService;
    private $stateParams:any;
    private document:duScroll.IDocumentService;
    private store:ng.a0.storage.IStoreService;
    private browserControlService:IBrowserControlService;
    private questionnaire:IQuestionnaire;
    private sessionService:ISessionService;
    private sharedQuestionService:SharedQuestionService;
    private logicService:IQuestionnaireLogicService;
    private translationService:ITranslationService;
    private themerService:IThemerService;
    private loggerService:LoggerService;
    private spinnerService:SpinnerService;
    private errorService:ErrorService;
    private luminaEnv: any;

    question:IQuestion;
    questionComponent:string;

    defaultNextQuestionText   = 'next_question';
    nextQuestionText          = this.defaultNextQuestionText;
    canPreviousQuestion:boolean;
    canSkipQuestion:boolean;
    progress:ISessionProgress = {
        currentQuestion: 0,
        answered       : 0,
        questions      : 0
    };
    showPagination            = true;
    hasPreviousQuestion       = false;
    beforeJump:IQuestion      = null;

    exitRedirect:string = null;

    private allowTimeouts = true;
    private questionTimeout:angular.IPromise<any>;
    private autosaveInterval:angular.IPromise<any>;
    private autosaveTime:number = 5000;

    private changeLanguageContinueFired:boolean = false;

    private errorModals:ISessionErrorModals      = {
        invalidUrl: {
            title   : 'error_invalid_url_title',
            body    : 'error_invalid_url_body',
            redirect: 'error_invalid_url_redirect'
        }
    };
            currentErrorModal:ISessionErrorModal = null;
            currentRedirectTimeout:number = 5;

    static $inject = [
        '$rootScope',
        '$scope',
        '$location',
        '$q',
        '$window',
        '$timeout',
        '$interval',
        '$route',
        '$stateParams',
        '$document',
        'store',
        'BrowserControlService',
        'questionnaire',
        'SessionService',
        'SharedQuestionService',
        'QuestionnaireLogicService',
        'TranslationService',
        'ThemerService',
        'LoggerService',
        'SpinnerService',
        'ErrorService',
        'luminaEnv',
    ];

    constructor($rootScope:IRootScope,
                $scope:ng.IScope,
                $location:ng.ILocationService,
                $q:ng.IQService,
                $window:ng.IWindowService,
                $timeout:ng.ITimeoutService,
                $interval:ng.IIntervalService,
                $route:ng.route.IRouteService,
                $stateParams:any,
                $document:duScroll.IDocumentService,
                store:ng.a0.storage.IStoreService,
                browserControlService:IBrowserControlService,
                questionnaire:IQuestionnaire,
                SessionService:ISessionService,
                SharedQuestionService:SharedQuestionService,
                QuestionnaireLogicService:IQuestionnaireLogicService,
                TranslationService:ITranslationService,
                ThemerService:IThemerService,
                LoggerService:LoggerService,
                SpinnerService:SpinnerService,
                ErrorService:ErrorService,
                luminaEnv: any) {

        this.rootScope             = $rootScope;
        this.scope                 = $scope;
        this.location              = $location;
        this.q                     = $q;
        this.window                = $window;
        this.timeout               = $timeout;
        this.interval              = $interval;
        this.route                 = $route;
        this.$stateParams           = $stateParams;
        this.document              = $document;
        this.store                 = store;
        this.browserControlService = browserControlService;
        this.questionnaire         = questionnaire;
        this.sessionService        = SessionService;
        this.sharedQuestionService = SharedQuestionService;
        this.logicService          = QuestionnaireLogicService;
        this.translationService    = TranslationService;
        this.themerService         = ThemerService;
        this.loggerService         = LoggerService;
        this.spinnerService        = SpinnerService;
        this.errorService          = ErrorService;
        this.luminaEnv             = luminaEnv;

        this.spinnerService.show();

        const waitForTimeoutToInit = () => {

            if (!this.rootScope.isAuthServiceLoaded) {
                this.timeout(waitForTimeoutToInit, 100);
                return;
            }

            this.init();
        };

        waitForTimeoutToInit();
    }

    private init() {
        const upid = this.$stateParams['upid'],
              raterGuid  = this.$stateParams['raterGuid'];

        // setup exit-redirect url
        let exitRedirectRoute = this.$stateParams['exit-redirect'];
        if (exitRedirectRoute) {
            this.exitRedirect = exitRedirectRoute;
        }

        this.sessionService.setExitRedirectURL(this.generateExitRedirectURL());

        this.rootScope.headerTitle = this.questionnaire.title;

        //if (this.questionnaire.meta) {
        //    this.rootScope.headerLogo = this.questionnaire.meta.logo;
        //}
        this.rootScope.$emit('headerLogos', this.questionnaire);

        if (this.questionnaire.meta.styles) {
            this.themerService.setSelectors(this.questionnaire.meta.styles);
        }

        let profile:any = this.store.get('profile');
        this.translationService.userUp(profile.user_metadata.locale).then(() => {

            let locales = this.questionnaire.meta.locales;
            if (!locales || locales.length <= 0) {
                locales = null;
            }

            this.translationService.questionnaireUp(locales);

            this.sessionService.resumeSession(this.questionnaire.id, upid, raterGuid).then((session:any) => {
                if (this.store.get('profile').impersonated) {
                    this.loggerService.log(LoggerKey.Impersonated, {
                        impersonator: this.store.get('profile').impersonator
                    });
                }

                // set the logo
                if (session.practitioner && session.practitioner.logo) {
                    this.setPractitionerLogo(session.practitioner.logo);
                }

                // if can be resumed set locale and loads next question
                let locale = null;
                if (session.context.locale) {
                    locale = session.context.locale;
                }

                if (session.context.exit_redirect) {
                    this.exitRedirect = session.context.exit_redirect;
                    this.sessionService.setExitRedirectURL(this.generateExitRedirectURL());
                }

                this.translationService.sessionUp(locale);

                this.logicService.setQuestionnaire(this.questionnaire).then(() => {
                    return this.logicService.resume().then(() => {
                        this.loadCurrentQuestion();
                    });
                });
            }, () => {
                // if rate param is required, show the error message
                if (!raterGuid && this.questionnaire.meta.rater) {
                    this.handleError(this.errorModals['invalidUrl']);
                    return this.q.reject();
                }

                // if cannot be resumed starts a new session
                return this.sessionService.createSession(this.questionnaire.id, upid, raterGuid, this.exitRedirect).then(value => {
                    if (value.status !== 200) {
                        return this.q.reject(value);
                    }

                    this.sessionService.activeSession = {
                        id             : value.data.id,
                        questionnaireId: this.questionnaire.id,
                        context        : 'user_id:' + this.store.get('profile').user_id,
                        timezone       : moment.tz.guess()
                    };

                    if (value.data.practitioner && value.data.practitioner.logo) {
                        this.setPractitionerLogo(value.data.practitioner.logo);
                    }

                    this.logicService.setQuestionnaire(this.questionnaire).then(() => {
                        this.loadCurrentQuestion();

                        this.loggerService.log(LoggerKey.Language, {
                            locale: this.translationService.getCurrentLanguage().locale
                        });
                    });
                }).catch((value) => {
                    this.handleError(this.errorModals['invalidUrl']);
                });
            }).finally(() => {
                this.browserControlService.disableBackButton(() => {
                    if (this.canPreviousQuestion) {
                        this.previousQuestion();
                    }
                });

                const sessionId = this.sessionService.activeSession.id;

                // setup language change event
                this.translationService.onLanguageChange(() => {
                    this.loggerService.log(LoggerKey.Language, {
                        locale: this.translationService.getCurrentLanguage().locale
                    });

                    if (this.changeLanguageContinueFired === true) {
                        this.changeLanguageContinueFired = false;
                        return;
                    }

                    angular.element('#session-changed-language-modal').modal({
                        keyboard: false,
                        backdrop: 'static'
                    }).modal('show');

                    this.sessionService.sessionPaused();
                });

                this.setupReminders();

                let autosaveOnSessionPaused = true;

                // setup deconstructors for events
                const destroyOnLostConnection   = this.errorService.onLostConnection(() => {
                          autosaveOnSessionPaused = false;
                          this.sessionService.sessionPaused();
                          autosaveOnSessionPaused = true;
                      }),
                      destroyOnResumeConnection = this.errorService.onResumeConnection(() => {
                          this.sessionService.sessionResumed();
                      }),
                      destroyOnSessionResume    = this.sessionService.onSessionResumed(() => {
                          this.setupTimeout();
                          this.setupAutosave();
                      }),
                      destroyOnSessionPaused    = this.sessionService.onSessionPaused(() => {
                          if (autosaveOnSessionPaused) {
                              this.autosave();
                          }

                          this.cancelAutosave();
                          this.cancelTimeout();
                      });

                this.scope.$on('$destroy', () => {
                    // brings back browser controls
                    this.browserControlService.enableBackButton();
                    this.themerService.setDefaults();
                    this.sessionService.sessionPaused();
                    this.translationService.questionnaireDown();
                    this.translationService.sessionDown();

                    destroyOnLostConnection();
                    destroyOnResumeConnection();
                    destroyOnSessionResume();
                    destroyOnSessionPaused();

                    this.sessionService.isReady = false;
                });

                this.spinnerService.hide();
                this.sessionService.isReady = true;
            });
        });
    }

    loadCurrentQuestion() {
        this.question = this.logicService.getCurrentQuestion();
        this.location.search('question', this.question.id);

        this.showPagination      = true;
        this.hasPreviousQuestion = this.logicService.getPreviousQuestions().length !== 0;

        this.questionComponent = '<' + this.question.type + '-question question="session.question" ' +
            'question-id="' + this.question.id + '" ' +
            'previous-question-callback="session.previousQuestion()" ' +
            'next-question-callback="session.nextQuestion()" ' +
            'previous-question-jump-callback="session.previousQuestionJump(id)" ' +
            'show-session-pagination="session.showPagination"' +
            'has-previous-question="session.hasPreviousQuestion"' +
            '></' + this.question.type + '-question>';

        this.nextQuestionText    = this.question.meta.nextQuestionText ? this.question.meta.nextQuestionText : this.defaultNextQuestionText;
        this.canPreviousQuestion = !this.logicService.isFirstQuestion();
        this.canSkipQuestion     = !this.question.required;

        this.setupTimeout();
        this.setupAutosave();

        this.progress = this.logicService.getProgress();
        this.sessionService.setExitRedirectURL(this.generateExitRedirectURL());
    }

    private setupReminders() {
        if (!this.questionnaire.meta.reminders) {
            return;
        }


    }

    // @TODO: not only time but also interaction (maybe that should be "Having trouble deciding a response?")
    private setupTimeout() {
        this.cancelTimeout();

        if (this.allowTimeouts && this.question.timeout && isFinite(this.question.timeout)) {
            this.questionTimeout = this.timeout(() => {
                angular.element('#timeout-modal').modal({
                    keyboard: false,
                    backdrop: 'static'
                }).modal('show');

                this.loggerService.log(LoggerKey.Timeout, {
                    question_id: this.question.id,
                });
                this.sessionService.sessionPaused();
            }, this.question.timeout);
        }
    }

    private cancelTimeout() {
        if (this.questionTimeout) {
            this.timeout.cancel(this.questionTimeout);
        }
    }

    private setupAutosave() {
        this.cancelAutosave();

        this.autosaveInterval = this.interval(() => {
            this.autosave();
        }, this.autosaveTime);
    }

    private cancelAutosave() {
        if (this.autosaveInterval) {
            this.interval.cancel(this.autosaveInterval);
        }
    }

    private autosave():ng.IPromise<any> {
        let promises:ng.IPromise<any>[] = [];

        for (let sharedQuestion of this.sharedQuestionService.questions) {
            sharedQuestion.preventValidation(() => {
                if (sharedQuestion.isValid()) {
                    promises.push(this.saveSharedQuestion(sharedQuestion, false));
                }
            });
        }

        return this.q.all(promises);
    }

    public onTimeoutExit() {
        this.loggerService.log(LoggerKey.Timeout, {
            question_id: this.question.id,
            action     : 'saveAndExit'
        });

        this.autosave().finally(() => {
            this.timeout(() => {
                this.exit(false);
            }, 1000);
        });
    }

    public onTimeoutContinue() {
        this.loggerService.log(LoggerKey.Timeout, {
            question_id: this.question.id,
            action     : 'continue'
        });
        this.sessionService.sessionResumed();
    }

    public onTimeoutTurnOff() {
        this.allowTimeouts = false;
        this.onTimeoutContinue();
    }

    public onChangeLanguageRestart() {
        // save and finish session after global language update posted
        this.translationService.updateGlobalLanguage()
            .finally(() => { //we run the local change on global success or failure
                this.finish('restarted').then(
                    () => {
                        this.loggerService.log(LoggerKey.Language, {
                            action: 'restart'
                        });

                        this.window.location.reload(true);
                    }
                );
            });
        return;
    }

    public onChangeLanguageContinue() {
        this.changeLanguageContinueFired = true;
        this.translationService.bringBackPreviousLanguage();
        this.loggerService.log(LoggerKey.Language, {
            action: 'continue'
        });
    }

    private duringPreviousQuestion = false;

    previousQuestion() {
        const previousQuestion:() => ng.IPromise<any> = () => {
            const currentQuestionId = this.question.id;
            return this.autosave().finally(() => {
                return this.logicService.previousQuestion().then(() => {
                    this.loggerService.log(LoggerKey.CurrentQuestion, {
                        action          : 'previous_question',
                        from_question_id: currentQuestionId,
                        to_question_id  : this.logicService.getCurrentQuestion().id
                    });
                    this.loadCurrentQuestion();
                });
            });
        };

        if (!this.duringPreviousQuestion) {
            this.duringPreviousQuestion = true;
            this.processBeforeJump();
            this.spinnerService.show();
            previousQuestion().finally(() => {
                this.duringPreviousQuestion = false;
                this.spinnerService.hide();
            });
        }
    }

    validateSharedQuestions():ng.IPromise<any> {
        if (!this.sharedQuestionService.isValid()) {
            return this.q.reject();
        }

        for (let sharedQuestion of this.sharedQuestionService.questions) {
            let previouslyAnswered = false;
            for (let answer of this.sessionService.answers) {
                if (answer.questionId === sharedQuestion.question.id) {
                    previouslyAnswered = true;
                    break;
                }
            }

            if (previouslyAnswered) {
                continue;
            }

            if (this.rootScope.disableAnsweredTooFast) {
                continue;
            }

            const minTime = sharedQuestion.question.meta.minTime;
            if (
                sharedQuestion.question.required !== false &&
                minTime &&
                isFinite(minTime) &&
                minTime >= sharedQuestion.getQuestionTime().asMilliseconds()
            ) {
                this.answeredTooFast(sharedQuestion);
                return this.q.reject();
            }
        }

        return this.q.resolve();
    }

    private duringNextQuestion = false;

    nextQuestion(logAction:string = 'next_question') {
        const saveAndFinish:() => ng.IPromise<any> = () => {
            // save and finish session
            return this.finish().then(() => {
                this.exit(true);
                return this.q.reject();
            });
        };

        const nextQuestion:() => ng.IPromise<any> = () => {
            const currentQuestionId = this.question.id;

            return this.validateSharedQuestions().then(() => {
                this.sessionService.sessionPaused();
                this.cancelAutosave();

                return this.saveQuestions().then(() => {
                    return this.reminders().then(() => {
                        return this.logicService.nextQuestion().then(() => {
                            if (this.logicService.isLastQuestion() && currentQuestionId === this.logicService.getCurrentQuestion().id) {
                                return saveAndFinish();
                            }

                            this.loggerService.log(LoggerKey.CurrentQuestion, {
                                action          : 'next_question',
                                from_question_id: currentQuestionId,
                                to_question_id  : this.logicService.getCurrentQuestion().id
                            });

                            this.processBeforeJump();
                            this.loadCurrentQuestion();
                            this.scrollToTop();

                            return this.q.resolve();
                        }).catch(() => {
                            if (this.logicService.isLastQuestion()) {
                                return saveAndFinish();
                            }
                        });
                    });
                });
            });
        };

        if (!this.duringNextQuestion) {
            this.duringNextQuestion = true;
            this.spinnerService.show();
            nextQuestion().finally(() => {
                this.sessionService.sessionResumed();

                this.duringNextQuestion = false;
                this.spinnerService.hide();
            });
        }
    }

    private duringSkipQuestion = false;

    skipQuestion() {
        this.nextQuestion('skip_question');
    }

    previousQuestionJump(id:number) {
        const previousQuestion:() => ng.IPromise<any> = () => {
            const currentQuestionId = this.question.id,
                  previousQuestions = this.logicService.getPreviousQuestions(),
                  search            = (id:number, questions:IQuestion[]) => {
                      for (const question of questions) {
                          if (question.id === id) {
                              return question.id;
                          }

                          const subQuestions = question.questions;
                          if (subQuestions && subQuestions.length > 0) {
                              if (search(id, subQuestions)) {
                                  return question.id;
                              }
                          }
                      }

                      return null;
                  };

            id = search(id, previousQuestions);

            return this.autosave().finally(() => {
                return this.logicService.previousQuestionJump(id).then(() => {
                    this.loggerService.log(LoggerKey.CurrentQuestion, {
                        action          : 'previous_question_jump',
                        from_question_id: currentQuestionId,
                        to_question_id  : this.logicService.getCurrentQuestion().id
                    });
                    this.beforeJump = this.question;
                    this.loadCurrentQuestion();
                });
            });
        };

        if (!this.duringPreviousQuestion) {
            this.duringPreviousQuestion = true;
            this.spinnerService.show();
            previousQuestion().finally(() => {
                this.duringPreviousQuestion = false;
                this.spinnerService.hide();
            });
        }
    }

    jumpBack() {
        const jump:() => ng.IPromise<any> = () => {
            const currentQuestionId = this.question.id;

            return this.validateSharedQuestions().then(() => {
                return this.saveQuestions().finally(() => {
                    return this.logicService.jumpBack().then(() => {
                        this.loggerService.log(LoggerKey.CurrentQuestion, {
                            action          : 'jump_back',
                            from_question_id: currentQuestionId,
                            to_question_id  : this.logicService.getCurrentQuestion().id
                        });

                        this.processBeforeJump();
                        this.loadCurrentQuestion();
                    });
                });
            });
        };

        if (!this.duringNextQuestion) {
            this.duringNextQuestion = true;
            this.spinnerService.show();
            jump().finally(() => {
                this.duringNextQuestion = false;
                this.spinnerService.hide();
            });
        }
    }

    private handleError(errorModal:ISessionErrorModal) {
        this.currentErrorModal = errorModal;

        if (this.currentErrorModal.redirect) {
            this.interval(() => {
                if (this.currentRedirectTimeout > 0) {
                    this.currentRedirectTimeout--;
                    return;
                }

                this.exit(false);
            }, 1000);
        }

        angular.element('#session-error-modal').modal({
            keyboard: false,
            backdrop: 'static'
        }).modal('show');
    }

    private processBeforeJump() {
        if (!this.beforeJump) {
            return;
        }

        // at this point this.question is not yet set by the loadCurrentQuestion method but set by the logic service
        const newCurrentQuestion = this.logicService.getCurrentQuestion();

        // so we can check whether the new current question is equal to
        // the before jump one to dismiss the "go back button"
        if (newCurrentQuestion.id === this.beforeJump.id) {
            this.beforeJump = null;
        }
    }

    private answeredTooFast(sharedQuestion:SharedQuestion) {
        angular.element('#answered-too-fast-modal').modal({
            keyboard: false,
            backdrop: 'static'
        }).modal('show');

        this.loggerService.log(LoggerKey.AnsweredTooFast, {
            question_id: sharedQuestion.question.id,
            time       : sharedQuestion.getQuestionTime()
        });

        this.autosave();

        // cancel timeouts
        this.cancelTimeout();
        this.cancelAutosave();
    }

    onAnsweredTooFastOK() {
        this.sharedQuestionService.sessionResumed();
        this.setupTimeout();
        this.setupAutosave();
    }

    private finish(status = 'finished'):ng.IPromise<any> {
        return this.loggerService.log(LoggerKey.Session, {
            status: 'finish'
        }).finally(() => {
            return this.sessionService.finishSession(status).then(() => {
                return this.q.resolve();
            });
        });
    }

    private exit(questionnaireCompleted:boolean = true) {
        this.browserControlService.enableBackButton();

        const chain = this.questionnaire.meta.chain;
        if (chain) {
            const path = '/questionnaire/' + chain;

            this.store.set('previous_questionnaire', this.questionnaire.id);

            if (this.location.path().indexOf(path) !== -1) {
                this.window.location.reload();
            }

            this.location.path(path).search('question', null);
        }

        this.sessionService.setExitRedirectURL(this.generateExitRedirectURL(questionnaireCompleted));
        this.sessionService.exitRedirect();
    }

    private saveQuestions() {
        let promises:ng.IPromise<any>[] = [];

        for (let sharedQuestion of this.sharedQuestionService.questions) {
            const promise = this.saveSharedQuestion(sharedQuestion, true);

            promises.push(promise);
        }

        return this.q.all(promises);
    }

    private saveSharedQuestion(sharedQuestion:SharedQuestion, answered?:boolean):ng.IPromise<any> {
        let timing     = sharedQuestion.questionAnswered(false);
        let questionId = sharedQuestion.question ? sharedQuestion.question.id : this.question.id;
        let value:any  = sharedQuestion.getValue();
        let values     = angular.isArray(value) ? value : [value];

        if (value && angular.isArray(value) && value.length === 0) {
            return this.q.reject();
        }

        let answer = this.getAnswerForQuestionId(questionId);
        if (!answered && answer && angular.equals(answer.values, values)) {
            return this.q.resolve();
        }

        return this.sessionService.saveAnswer({
            questionId : questionId,
            displayedAt: timing.displayedAt,
            answeredAt : timing.answeredAt,
            time       : timing.time,
            values     : values
        }, this.beforeJump !== null);
    }

    private remindersOccured: {id: number}[] = [];

    private reminders():ng.IPromise<any> {
        if (!this.questionnaire.meta.reminders) {
            return this.q.resolve();
        }

        // @TODO: should be checking answers what as well

        const reminders = this.questionnaire.meta.reminders;
        for (let reminderId = 0; reminderId < reminders.length; reminderId++) {
            const reminder = reminders[reminderId];

            switch (reminder.on) {
                case 'empty':
                    let shouldRemind = false;
                    for (let sharedQuestion of this.sharedQuestionService.questions) {
                        for (let afterQuestionId of reminder.after) {
                            if (sharedQuestion.question.id === afterQuestionId) {
                                shouldRemind = true;
                                break;
                            }
                        }

                        if (shouldRemind) {
                            break;
                        }
                    }

                    if (!shouldRemind) {
                        break;
                    }

                    const previousQuestions = this.logicService.getPreviousQuestions().concat(this.logicService.getCurrentQuestion());
                    let foundQuestions = [];
                    SharedQuestionService.recursiveForEachQuestions(previousQuestions, function (previousQuestion) {
                        for (let questionId of reminder.questionIds) {
                            if (questionId === previousQuestion.id) {
                                foundQuestions.push(previousQuestion);
                            }
                        }
                    });

                    if (foundQuestions.length !== reminder.questionIds.length) {
                        break;
                    }

                    let foundAnswer = false;
                    for (let foundQuestion of foundQuestions) {
                        const sharedQuestion = new this.sharedQuestionService.sharedQuestions[foundQuestion.type](),
                              answer         = this.getAnswerForQuestionId(foundQuestion.id);

                        if (!sharedQuestion.isAnswerEmpty(answer)) {
                            foundAnswer = true;
                            break;
                        }
                    }

                    if (foundAnswer) {
                        break;
                    }

                    if (!reminder.repeat) {
                        let occured = false;
                        for (let occuredReminder of this.remindersOccured) {
                            if (occuredReminder.id === reminderId) {
                                occured = true;
                                break;
                            }
                        }

                        if (occured) {
                            break;
                        }
                    }

                    this.remindersOccured.push({
                        id: reminderId
                    });

                    // show reminder
                    this.handleError({
                        title: reminder.message.title,
                        body: reminder.message.body,
                        button: {
                            title: reminder.message.button,
                            click: () => {
                                angular.element('#session-error-modal').modal({
                                    keyboard: false,
                                    backdrop: 'static'
                                }).modal('hide');
                            }
                        }
                    });

                    return this.q.reject();
                default:
                    break;
            }
        }

        return this.q.resolve();
    }

    private getAnswerForQuestionId(id:number):IAnswer {
        for (let answer of this.sessionService.answers) {
            if (answer.questionId === id) {
                return answer;
            }
        }

        return null;
    }

    private scrollToTop() {
        const element = angular.element('.navbar');
        if (element) {
            this.document.duScrollToElementAnimated(element);
        }
    }

    private setPractitionerLogo(logo:string) {
        const logos = this.questionnaire.meta.logos;

        if (logo && logo.length > 0 && logo !== 'https://www.luminalearning.com/cms/assets/images/logo_lumina@2x.png') {
            if (logos.mobile && logos.mobile.secondary && logos.mobile.secondary.length <= 0) {
                logos.mobile.secondary = logo;
            }

            if (logos.desktop && logos.desktop.left && logos.desktop.left.length <= 0) {
                logos.desktop.left = logo;
            }

            this.rootScope.$emit('headerLogos', this.questionnaire);
        }
    }

    private generateExitRedirectURL(questionnaireCompleted: boolean = false): string {
        let redirect = this.exitRedirect ? this.exitRedirect : this.questionnaire.meta.exitRedirect;
        redirect     = redirect ? redirect : this.luminaEnv.ssoUrl + '/portal';
        redirect     = this.addUrlParameter(redirect, 'sessionCompleted', questionnaireCompleted);
        redirect     = this.addUrlParameter(redirect, 'questionnaireSlug', this.$stateParams['slug']);
        redirect     = this.addUrlParameter(redirect, 'sessionUPID', this.$stateParams['upid']);

        if (this.progress.questions > 0) {
            let progress = Math.round((this.progress.currentQuestion / this.progress.questions) * 100);
            // Leader: 96/95 = 1.0105
            // Using floor or ceil will not escape progress=101
            progress = progress > 100 ? 100 : progress;
            redirect = this.addUrlParameter(redirect, 'sessionProgress', progress);
        }

        if (this.$stateParams['rater-guid']) {
            redirect = this.addUrlParameter(redirect, 'sessionCID', this.$stateParams['rater-guid']);
        }

        return redirect;
    }

    private addUrlParameter(url, paramName, paramValue) {
        var hash = location.hash;
        url = url.replace(hash, '');
        if (url.indexOf(paramName + '=') >= 0) {
            var prefix = url.substring(0, url.indexOf(paramName));
            var suffix = url.substring(url.indexOf(paramName));
            suffix = suffix.substring(suffix.indexOf('=') + 1);
            suffix = (suffix.indexOf('&') >= 0) ? suffix.substring(suffix.indexOf('&')) : '';
            url = prefix + paramName + '=' + paramValue + suffix;
        } else {
            if (url.indexOf('?') < 0) {
                url += '?' + paramName + '=' + paramValue;
            } else {
                url += '&' + paramName + '=' + paramValue;
            }
        }

        return url + hash;
    }

}

app.controller('SessionController', SessionController);